/**
 * RBAC: phân quyền theo role (superadmin, tenant_admin, user).
 * Backend trả về is_superuser, datahub_role qua GET /users/me.
 */

export const ROLE_USER = 'user';
export const ROLE_TENANT_ADMIN = 'tenant_admin';

/**
 * User có quyền tạo project không (Superadmin hoặc Tenant Admin).
 * @param {{ is_superuser?: boolean, datahub_role?: string }} user - object user từ account (GET /users/me)
 */
export function canCreateProject(user) {
    if (!user) return false;
    if (user.is_superuser === true) return true;
    return user.datahub_role === ROLE_TENANT_ADMIN;
}

/**
 * Có phải Superadmin không.
 */
export function isSuperadmin(user) {
    return !!user?.is_superuser;
}

/**
 * Nhãn role để hiển thị UI.
 */
export function getRoleLabel(user) {
    if (!user) return '';
    if (user.is_superuser) return 'Superadmin';
    if (user.datahub_role === ROLE_TENANT_ADMIN) return 'Tenant Admin';
    return 'User';
}

/**
 * User có quyền quản lý thành viên project (owner, tenant_admin của project, hoặc superadmin).
 * @param {{ user_token?: string, tenant_admin_user_id?: string }} project - project từ list
 * @param {{ id?: string, user_token?: string, is_superuser?: boolean }} user - current user
 */
export function canManageProjectMembers(project, user) {
    if (!user || !project) return false;
    if (user.is_superuser) return true;
    if (project.user_token === user.user_token) return true;
    if (project.tenant_admin_user_id && String(project.tenant_admin_user_id) === String(user.id)) return true;
    return false;
}
